import { faBuilding, faWater } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const ForecastMapRightSideButtons = () => {
  return (
    <div className="forecast-map-right-side-btn-container">
      <div className="forecast-map-right-btns">
        <FontAwesomeIcon
          size="1x"
          icon={faBuilding}
          onClick={() => {
          
          }}
        />
      </div>
      <div className="forecast-map-right-btns">
        <FontAwesomeIcon
          size="1x"
          icon={faWater}
          onClick={() => {
           
          }}
        />
      </div>
    </div>
  );
};

export default ForecastMapRightSideButtons;
